const CountryCoords = () => {
    return {
        "Newfoundland and Labrador (Canada)": {
            "centroid": [
                56.117,
                -62.6399
            ],
            "zoom": 5.5
        },
        "Prince Edward Island (Canada)": {
            "centroid": [
                46.5076,
                -63.6108
            ],
            "zoom": 5.5
        },
        "Nova Scotia (Canada)": {
            "centroid": [
                44.7411,
                -64.4669
            ],
            "zoom": 5.5
        },
        "New Brunswick (Canada)": {
            "centroid": [
                46.5868,
                -66.2547
            ],
            "zoom": 5.5
        },
        "Quebec (Canada)": {
            "centroid": [
                54.813,
                -73.1686
            ],
            "zoom": 6
        },
        "Ontario (Canada)": {
            "centroid": [
                49.9575,
                -87.0374
            ],
            "zoom": 6
        },
        "Manitoba (Canada)": {
            "centroid": [
                54.8606,
                -96.9753
            ],
            "zoom": 6
        },
        "Saskatchewan (Canada)": {
            "centroid": [
                54.894,
                -105.9448
            ],
            "zoom": 6
        },
        "Alberta (Canada)": {
            "centroid": [
                54.883,
                -115.0022
            ],
            "zoom": 6
        },
        "British Columbia (Canada)": {
            "centroid": [
                54.8721,
                -125.0358
            ],
            "zoom": 6
        },
        "Yukon (Canada)": {
            "centroid": [
                65.2611,
                -136.8349
            ],
            "zoom": 6
        },
        "Northwest Territories (Canada)": {
            "centroid": [
                65.8249,
                -123.0981
            ],
            "zoom": 6
        },
        "Nunavut (Canada)": {
            "centroid": [
                80.2201,
                -77.5824
            ],
            "zoom": 6
        },
        "Alabama (USA)": {
            "centroid": [
                32.6483,
                -86.7411
            ],
            "zoom": 6
        },
        "Alaska (USA)": {
            "centroid": [
                64.3151,
                -151.0647
            ],
            "zoom": 6
        },
        "Arizona (USA)": {
            "centroid": [
                34.2195,
                -111.6252
            ],
            "zoom": 6
        },
        "Arkansas (USA)": {
            "centroid": [
                34.7706,
                -92.4991
            ],
            "zoom": 6
        },
        "California (USA)": {
            "centroid": [
                37.4213,
                -120.105
            ],
            "zoom": 6
        },
        "Colorado (USA)": {
            "centroid": [
                39.0275,
                -105.5494
            ],
            "zoom": 6
        },
        "Connecticut (USA)": {
            "centroid": [
                41.5196,
                -72.8052
            ],
            "zoom": 6
        },
        "Delaware (USA)": {
            "centroid": [
                39.1489,
                -75.5806
            ],
            "zoom": 6
        },
        "District of Columbia (USA)": {
            "centroid": [
                38.8938,
                -76.988
            ],
            "zoom": 6
        },
        "Florida (USA)": {
            "centroid": [
                28.0182,
                -81.5978
            ],
            "zoom": 6
        },
        "Georgia (USA)": {
            "centroid": [
                32.7089,
                -83.2723
            ],
            "zoom": 6
        },
        "Hawaii (USA)": {
            "centroid": [
                19.591,
                -155.4496
            ],
            "zoom": 6
        },
        "Idaho (USA)": {
            "centroid": [
                45.6039,
                -115.502
            ],
            "zoom": 6
        },
        "Illinois (USA)": {
            "centroid": [
                39.7947,
                -89.4489
            ],
            "zoom": 6
        },
        "Indiana (USA)": {
            "centroid": [
                39.795,
                -86.1737
            ],
            "zoom": 6
        },
        "Iowa (USA)": {
            "centroid": [
                41.9582,
                -93.1479
            ],
            "zoom": 6
        },
        "Kansas (USA)": {
            "centroid": [
                38.5139,
                -98.3287
            ],
            "zoom": 6
        },
        "Kentucky (USA)": {
            "centroid": [
                37.8343,
                -84.7305
            ],
            "zoom": 6
        },
        "Louisiana (USA)": {
            "centroid": [
                31.0725,
                -92.5489
            ],
            "zoom": 6
        },
        "Maine (USA)": {
            "centroid": [
                45.305,
                -69.1354
            ],
            "zoom": 6
        },
        "Maryland (USA)": {
            "centroid": [
                38.8855,
                -76.7316
            ],
            "zoom": 6
        },
        "Massachusetts (USA)": {
            "centroid": [
                42.1881,
                -72.0951
            ],
            "zoom": 6
        },
        "Michigan (USA)": {
            "centroid": [
                43.7777,
                -85.1863
            ],
            "zoom": 6
        },
        "Minnesota (USA)": {
            "centroid": [
                46.319,
                -94.4467
            ],
            "zoom": 6
        },
        "Mississippi (USA)": {
            "centroid": [
                32.6194,
                -89.6933
            ],
            "zoom": 6
        },
        "Missouri (USA)": {
            "centroid": [
                38.3443,
                -92.4894
            ],
            "zoom": 6
        },
        "Montana (USA)": {
            "centroid": [
                46.7293,
                -109.3459
            ],
            "zoom": 6
        },
        "Nebraska (USA)": {
            "centroid": [
                41.518,
                -100.0598
            ],
            "zoom": 6
        },
        "Nevada (USA)": {
            "centroid": [
                38.5916,
                -116.7303
            ],
            "zoom": 6
        },
        "New Hampshire (USA)": {
            "centroid": [
                44.016,
                -71.5463
            ],
            "zoom": 6
        },
        "New Jersey (USA)": {
            "centroid": [
                40.1534,
                -74.3713
            ],
            "zoom": 6
        },
        "New Mexico (USA)": {
            "centroid": [
                34.215,
                -106.0453
            ],
            "zoom": 6
        },
        "New York (USA)": {
            "centroid": [
                42.9321,
                -76.0889
            ],
            "zoom": 6
        },
        "North Carolina (USA)": {
            "centroid": [
                35.2269,
                -80.4379
            ],
            "zoom": 6
        },
        "North Dakota (USA)": {
            "centroid": [
                47.4901,
                -100.4544
            ],
            "zoom": 6
        },
        "Ohio (USA)": {
            "centroid": [
                40.2135,
                -82.735
            ],
            "zoom": 6
        },
        "Oklahoma (USA)": {
            "centroid": [
                35.3258,
                -97.2171
            ],
            "zoom": 6
        },
        "Oregon (USA)": {
            "centroid": [
                44.1521,
                -120.5095
            ],
            "zoom": 6
        },
        "Pennsylvania (USA)": {
            "centroid": [
                41.0073,
                -77.809
            ],
            "zoom": 6
        },
        "Rhode Island (USA)": {
            "centroid": [
                41.6622,
                -71.6164
            ],
            "zoom": 6
        },
        "South Carolina (USA)": {
            "centroid": [
                33.6408,
                -80.568
            ],
            "zoom": 6
        },
        "South Dakota (USA)": {
            "centroid": [
                44.2358,
                -100.2539
            ],
            "zoom": 6
        },
        "Tennessee (USA)": {
            "centroid": [
                35.8349,
                -86.3183
            ],
            "zoom": 6
        },
        "Texas (USA)": {
            "centroid": [
                31.32,
                -99.8102
            ],
            "zoom": 6
        },
        "Utah (USA)": {
            "centroid": [
                39.546,
                -111.5495
            ],
            "zoom": 6
        },
        "Vermont (USA)": {
            "centroid": [
                43.8828,
                -72.7757
            ],
            "zoom": 6
        },
        "Virginia (USA)": {
            "centroid": [
                38.018,
                -78.4559
            ],
            "zoom": 6
        },
        "Washington (USA)": {
            "centroid": [
                47.3013,
                -119.7421
            ],
            "zoom": 6
        },
        "West Virginia (USA)": {
            "centroid": [
                38.941,
                -80.2144
            ],
            "zoom": 6
        },
        "Wisconsin (USA)": {
            "centroid": [
                44.7706,
                -90.368
            ],
            "zoom": 6
        },
        "Wyoming (USA)": {
            "centroid": [
                43.0349,
                -107.5486
            ],
            "zoom": 6
          },
         "United States": {
            centroid: [45.9507, -100.6531],
            zoom: 3.8,
          },
          "Canada": {
            centroid: [53.894,
                -105.9448],
            zoom: 3.8,
          }
      }
}

export default CountryCoords